import Model from "./abstract/Model";

export const Appearance = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',

  DEFAULT: 'LIGHT'
}

export default class UserPreference extends Model {

  appearance;

  constructor(props) {
    super();

    this.initializeAttributes(props, {});

    this.contract_columns_dict = (this.contract_columns ? this.contract_columns : []).reduce(function(map, obj) {
      map[obj] = true;
      return map;
    }, {});
  }
}
